import config from '../config.js';

const headers = {
  'accept': 'application/json',
  'Authorization': `Bearer ${config.API_KEY}`,
}

export const getPlayerInfo = async (nickname) => {
  const response = await fetch(`https://open.faceit.com/data/v4/players?nickname=${nickname}`, {
    method: 'GET',
    headers,
  });

  return response.json();
};

export const getPlayerMatchHistory = async (playerId, offset = 0, game = 'csgo') => {
  const response = await fetch(`https://open.faceit.com/data/v4/players/${playerId}/history?game=${game}&from=0&offset=${offset}`, {
    method: 'GET',
    headers,
  });

  const responseJson = await response.json();

  return responseJson;
};

export const getPlayerMatchStats = async (matchId) => {
  const response = await fetch (`https://open.faceit.com/data/v4/matches/${matchId}/stats`, {
    method: 'GET',
    headers,
  });

  return response.json();
};

export const getPlayerMatchStatsBulk = async (matchIds) => {
  const response = await Promise.all(matchIds.map((m) => (
    fetch (`https://open.faceit.com/data/v4/matches/${m}/stats`, {
      method: 'GET',
      headers,
    })
  )));

  const responseJson = await Promise.all(response.map((r) => r.json()));

  return responseJson;
};

export const getPlayerStats = async (playerId, gameId = 'csgo') => {
  const response = await fetch(`https://open.faceit.com/data/v4/players/${playerId}/stats/csgo`, {
    method: 'GET',
    headers
  });

  const responseJson = await response.json();

  return responseJson;
};
